class ProductPage extends HTMLElement {
  constructor() {
    super();
    this.bindSwiperObservers();
    this.addEventListener('product-page:refresh-observers', (ev) => {
      this.bindSwiperObservers();
    });
  }

  bindSwiperObservers() {
    let swiperSlides = this.querySelectorAll('#productGallery .swiper-slide');
    let ratioMap = [];

    swiperSlides.forEach((slide, key) => {
      // set up observer to have 0.01 intervals
      const options = {
        threshold: (() => {
          let thresholds = [];
          for (let i = 0; i <= 1.0; i += 0.01) {
            thresholds.push(i);
          }
          return thresholds;
        })(),
      };

      ratioMap[key] = 0;

      const slideObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          ratioMap[key] = entry.intersectionRatio;
          if (Math.max(...ratioMap) === entry.intersectionRatio) {
            window.dispatchEvent(
              new CustomEvent('product:active-image-change', {
                detail: entry.target.dataset.swiperSlideIndex,
              }),
            );
          }
        });
      }, options);

      slideObserver.observe(slide);
    });
  }
}

customElements.define('product-page', ProductPage);
